<template>
<div>
  <v-row no-gutters>
    <v-col :cols="colsMain">

      <v-row class="mgmt-panel">
      <Breadcrumbs :breadcrumbs="breadcrumbs" />

      </v-row>
      <hr />

      <StaticTabs :selected="activeTab" light class="elevation-0">
        <v-tab href="#info" @click="activeTab = 'info'">Инфо</v-tab>
        <v-tab v-if="current_user.id === item.user__id" href="#notification" @click="activeTab = 'notification'">Уведомления</v-tab>

        <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="info">
          <v-row no-gutters class="tab-row">
            <v-col :cols="cols13">
              <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-title class="primary--text">Информация</v-card-title>
                <v-card-text>
                  <table class="view-table" width="100%" >
                    <tr>
                      <th>ФИО:</th>
                      <td>{{ item.user__fio }}</td>
                    </tr>
                    <tr>
                      <th>Эл. почта:</th>
                      <td>{{ item.user__username }}</td>
                    </tr>
                    <tr>
                      <th>Адм. подразделение:</th>
                      <td>{{ item.division ? item.division.name : '---' }}</td>
                    </tr>
                    <tr>
                      <th>Должность:</th>
                      <td>{{ item.position ? item.position.name : '---' }}</td>
                    </tr>
                  </table>
                </v-card-text>
              </v-card>

              <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-title class="primary--text">Личные данные</v-card-title>
                <v-card-text>
                  <table class="view-table" width="100%" >
                    <tr>
                      <th class="view-table-list">Телефон:</th>
                      <td>
                        <ul class="view-table-list">
                          <li v-for="phone in item.phone" :key="phone">{{ phone }}</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <th>Вн. телефон:</th>
                      <td>{{ item.inner_phone }}</td>
                    </tr>
                    <tr>
                      <th>Место работы:</th>
                      <td>{{ item.place_of_work }}</td>
                    </tr>
                    <tr>
                      <th>Статус:</th>
                      <td>{{ item.notes }}</td>
                    </tr>
                  </table>
                </v-card-text>
              </v-card>

            </v-col>

            <v-col :cols="cols13">
              <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-text>
                    <div class="avatar-upload">
                      <div class="text-center p-2">
                          <img v-if="item.pic" :src="item.pic.url" class="rounded-circle" />
                          <img v-else src="/img/none.png" class="rounded-circle" />
                      </div>
                    </div>
                </v-card-text>
               </v-card>
            </v-col>

          </v-row>
        </v-tab-item>

        <!-- notification tab -->
        <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="notification">
          <v-row no-gutters class="tab-row">
            <v-col :cols="cols23">
              <UserNotification
                view="view"
                :item="item.usernotification"
              />
            </v-col>
          </v-row>
        </v-tab-item>

      </StaticTabs>
    </v-col>

  </v-row>
  <Confirmation
    :opened="confirmation.opened"
    :title="confirmation.title"
    :text="confirmation.text"
    :pendingSave="confirmation.pendingSave"
    @confirm="confirmConfirmationAction"
    @cancel="cancelConfirmationAction"
  />
</div>
</template>

<script>
import AddressBookFilter from '@/components/filters/AddressBookFilter'
import ViewMixin from '@/views/View.vue'
import UserNotification from '@/components/UserNotification'

export default {
  mixins: [ViewMixin],
  components: {
    AddressBookFilter,
    UserNotification
  },
  computed: {
  },
  data: function () {
    return {
      modelName: 'User',
      viewName: 'address_book',
      viewTitle: 'Адресная книга',
      parentHref: '#/address_book',

      urlObj: 'address_book_entry/',
      urlList: 'address_book/',

      // item
      item: {
        id: this.id,
        userinfo: {},
        name: ''
      },
      // collbar
      collbar: {
        url: 'address_book/',
        name: ''
      },

    }
  }
}
</script>
<style>
</style>
